import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SUMMARY"
      takeaways={[
        { text: "You may get a total of two questions from this module for CAT-1." },
        { text: "If you are unable to completely solve the problem, just remember how to solve it and write the overall process." },
        { text: "Recognizing the problem type—whether it involves solving or formation, and whether it is linear or non-linear—is crucial." },
      ]}
      videos={[]} // No videos provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSummary;
